module.exports = __webpack_public_path__ + "img/12-ui-install-guide-mockup.c89fd439.webp";